import { Table } from '@mantine/core'

export default {
  Table: Table.extend({
    defaultProps: {
      withColumnBorders: true,
      withTableBorder: true,
      highlightOnHover: true,
      highlightOnHoverColor: 'rgba(212, 219, 255, 0.3)',
      borderColor: 'rgba(102, 102, 102, 0.08)',
    },
    styles: (theme) => ({
      th: {
        color: theme.colors.blue[6],
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
      },
      thead: {
        background: '#f0f2f6b2',
      },
      td: {
        color: theme.colors.gray[5],
        fontSize: '13px',
        cursor: 'pointer',
      },
    }),
  }),
}
